export default "__VITE_ASSET__C4Iy7lVH__"